import { InjectionToken, Signal } from '@angular/core';
import { MenuPointToken } from '../interfaces/menu-point-token.interface';

export const MENU_POINTS: InjectionToken<MenuPointToken | Signal<MenuPointToken>> =
	new InjectionToken<MenuPointToken | Signal<MenuPointToken>>('MenuPoints');
